import { StateUpdatedEvent } from 'ag-grid-community';
import { useAtomCallback } from 'jotai/utils';
import { useCallback, useMemo } from 'react';
import { doOnGridStateUpdated, getStateToPersist, DefaultIgnoreList } from '../../../util/ag-grid-utils';
import { useSaveMprStateInView } from './mprViewActions';
import { mpReportingGridApi } from './MultiPeriodGrid';

export function useGetMprGridState() {
  return useAtomCallback(
    useCallback((get) => {
      const gridApi = get(mpReportingGridApi);
      if (!gridApi || gridApi.isRowDataEmpty()) {
        return;
      }
      return getStateToPersist(gridApi.getState(), DefaultIgnoreList);
    }, [])
  );
}

export function useSaveGridState() {
  const saveMprGridState = useSaveMprStateInView();
  const saveState = useMemo(
    () =>
      doOnGridStateUpdated((state) => {
        saveMprGridState({ gridState: state });
      }, DefaultIgnoreList),
    [saveMprGridState]
  );

  return useCallback(
    (event: StateUpdatedEvent) => {
      saveState(event);
    },
    [saveState]
  );
}
